import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';
import styles from './styles.module.scss';
import { useInView } from "react-intersection-observer";

export type TButtonContainedVariant = 'primary' | 'secondary' | 'transparent';

interface ButtonContainedProps extends ButtonHTMLAttributes<HTMLButtonElement> {
	variant: TButtonContainedVariant;
	children: ReactNode;
	isFullWidth?: boolean;
	isLoading?: boolean;
}

export const ButtonContained: React.FC<ButtonContainedProps> = ({
	variant = 'primary',
	children,
	isFullWidth = false,
	isLoading = false,
	className,
	...props
}) => {
  const { ref, inView } = useInView({
    threshold: 1,
  });

	const buttonClass = clsx(
		styles.button,
		{
			[styles['button--primary']]: variant === 'primary',
			[styles['button--secondary']]: variant === 'secondary',
			[styles['button--transparent']]: variant === 'transparent',
			[styles['button--full']]: isFullWidth,
			[styles['button--loading']]: isLoading,
		},
		className,
	);

	return (
		<button
      ref={ref}
			className={`${buttonClass} ${inView ? 'inView' : ''}`}
			disabled={isLoading || props.disabled}
			{...props}
		>
			{isLoading ? <span className={styles.loader}></span> : children}
		</button>
	);
};
